import { ReviewCardProps } from '../interfaces/common'
import wallet from '../assets/icons/wallet.svg'
import exportIcon from '../assets/icons/export-icon.svg'
import profile from '../assets/icons/profile-icon.svg'
import arrowRight from '../assets/icons/arrowRight.png'
import downloadIcon from "../assets/icons/Download.svg"
import resident from "../assets/icons/resident-light.svg"
import staff from "../assets/icons/staff-light.svg"
import { Artisan } from '../interfaces/services'




export const homeLinks = [
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
]
export const aboutLinks = [
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
]
export const faqLinks = [
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
]
export const contactLinks = [
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
]
export const signLinks = [
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
  { key: '1', text: '' },
]
export const NavItems = [
  { key: '', path: '/', label: 'Home' },
  { key: 'about', path: '/about', label: 'About Us' },
  { key: 'faq', path: '/faq', label: 'FAQ' },
  { key: 'contact-us', path: '/contact-us', label: 'Contact Us' },
  { key: 'auth/login', path: '/auth/login', label: 'Sign In' },
]

export const ReviewData: ReviewCardProps[] = [
  {
    name: 'Kathryn Murphy',
    email: 'Arlin@gmail.com',
    role: 'Landlord',
    description:
      'I was skeptical at first, but this app has really helped me feel more connected to my community. Love it!',
    estate: 'Amen Estate',
    date: 'June 31st 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/2.jpg',
  },
  {
    name: 'Theresa Webb',
    email: 'Arlin@gmail.com',
    role: 'Landlord',
    description:
      "The community app has been an amazing resource for me. I've found local events, joined groups, and even made some new friends!",
    estate: 'Amen Estate',
    date: 'June 31st 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/1.jpg',
  },
  {
    name: 'Esther Howard',
    email: 'esther.howard@gmail.com',
    role: 'Tenant',
    description:
      'This app makes it easy to stay informed about what is happening in the estate. I get updates quickly and never miss important notices.',
    estate: 'Amen Estate',
    date: 'May 14th 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/12.jpg',
  },
  {
    name: 'Robert Fox',
    email: 'robert.fox@gmail.com',
    role: 'Landlord',
    description:
      'Managing my property has become easier. I receive messages from residents and follow estate updates from one place.',
    estate: 'Sun City Estate',
    date: 'May 22nd 2024',
    imgSrc: 'https://randomuser.me/api/portraits/men/32.jpg',
  },
  {
    name: 'Jenny Wilson',
    email: 'jenny.wilson@gmail.com',
    role: 'Tenant',
    description:
      'I like how simple the app is to use. Reporting issues and getting feedback from management takes less time now.',
    estate: 'Cedarwood Gardens',
    date: 'June 4th 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    name: 'Darlene Robertson',
    email: 'darlene.robertson@gmail.com',
    role: 'Landlord',
    description:
      'The app keeps residents and landlords on the same page. Communication has improved since we started using it.',
    estate: 'Royal Palm Estate',
    date: 'June 12th 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
  {
    name: 'Savannah Nguyen',
    email: 'savannah.nguyen@gmail.com',
    role: 'Tenant',
    description:
      'The service request feature is useful. I reported a maintenance issue and received updates until it was resolved.',
    estate: 'Maple Court Estate',
    date: 'July 2nd 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/79.jpg',
  },
  {
    name: 'Jerome Bell',
    email: 'jerome.bell@gmail.com',
    role: 'Landlord',
    description:
      'I use the app to monitor announcements and communicate with my tenants. It saves time and keeps records organized.',
    estate: 'Oakridge Residence',
    date: 'July 9th 2024',
    imgSrc: 'https://randomuser.me/api/portraits/men/75.jpg',
  },
  {
    name: 'Kristin Watson',
    email: 'kristin.watson@gmail.com',
    role: 'Tenant',
    description:
      'The community directory helped me connect with neighbours and find services within the estate.',
    estate: 'Harmony Villas',
    date: 'July 16th 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/55.jpg',
  },
  {
    name: 'Wade Warren',
    email: 'wade.warren@gmail.com',
    role: 'Landlord',
    description:
      'I appreciate the clear announcements and estate notices. The app makes communication more reliable.',
    estate: 'Silvercrest Estate',
    date: 'July 24th 2024',
    imgSrc: 'https://randomuser.me/api/portraits/men/53.jpg',
  },
  {
    name: 'Courtney Henry',
    email: 'courtney.henry@gmail.com',
    role: 'Tenant',
    description:
      'I enjoy seeing updates from other residents. It gives the estate a stronger sense of community.',
    estate: 'Lakeview Gardens',
    date: 'August 1st 2024',
    imgSrc: 'https://randomuser.me/api/portraits/women/38.jpg',
  },
]



export const dashboardCardData = [
  {
    icon: wallet,
    bgColor: 'bg-[#0853E4]',
    cardBg: 'bg-[#0853E40F]',
    title: 'Total Income',
    subtitle: 'All received funds',
    value: 'NGN 600,000',
    trendText: '+2.3%',
    trendColor: 'text-[#069E2D]',
    trendIcon: exportIcon,
  },
  {
    icon: resident,
    bgColor: 'bg-[#7B61FF]',
    cardBg: 'bg-[#7B61FF0F]',
    title: 'Residents',
    subtitle: 'All users',
    value: '154',
    trendText: '-1.3%',
    trendColor: 'text-[#DD2C2F]',
    trendIcon: downloadIcon,
  },
  {
    icon: staff,
    bgColor: 'bg-[#FFAE1B]',
    cardBg: 'bg-[#FFAE1B0F]',
    title: 'Staffs',
    subtitle: 'All registered staffs',
    value: '30',
    trendText: '+1.3%',
    trendColor: 'text-[#069E2D]',
    trendIcon: exportIcon,
  },
  {
    icon: staff,
    bgColor: 'bg-[#259F46]',
    cardBg: 'bg-[#259F460F]',
    title: 'Staff',
    subtitle: 'Recent Logins',
    isProfileCard: true,
    profileImg: profile,
    actionText: 'Staff Profile',
    actionIcon: arrowRight,
  },
]




export const sampleArtisans: Artisan[] = [
  {
    id: '1',
    name: 'Cody Fisher',
    phone: '(671) 555-0110',
    email: 'michelle.rivera@example.com',
    serviceRequestCount: 2,
    avatar: '/assets/avatars/cody.jpg',
    serviceId: 'caregiving',
  },
  {
    id: '2',
    name: 'Jane Cooper',
    phone: '(316) 555-0116',
    email: 'tanya.hill@example.com',
    serviceRequestCount: 4,
    avatar: '/assets/avatars/jane.jpg',
    serviceId: 'cleaning',
  },
]

export const mockResident = {
  id: '1',
  resident: {
    flat: 'A-12',
    id: '1',
    name: 'John Doe',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john@example.com',
    phone: '08012345678',
    address: '4140 Parker Rd. Allentown, New Mexico 31134',
    isEmailVerified: true,
    imageUrl: '',
    status: 'active',
  },
  isOwner: true,
  accepted: true,
  isResident: true,
  isActive: true,
  address: 'Block A',
  residentType: {
    title: 'Owner',
    id: 'type1',
  },
  code: 'RES-001',

  properties: [
    {
      id: '1',
      property: 'Block A - 4517 Washington Ave. Manchester, Kentucky 39495',
      access: 'Enabled',
      levyStatus: 'Paid',
      validity: '31 Dec 2026',
    },
    {
      id: '2',
      property: 'Block B - 4140 Parker Rd. Allentown, New Mexico 31134',
      access: 'Disabled',
      levyStatus: 'Unpaid',
      validity: 'Expired',
    },

    {
      id: '3',
      property: '4517 Washington Ave. Manchester, Kentucky 39495',
      access: 'Enabled',
      levyStatus: 'Paid',
      validity: '11 Aug 2026',
    },

    {
      id: '4',
      property: 'Flat 12  4517 Washington Ave. Manchester, Kentucky 39495',
      access: 'Enabled',
      levyStatus: 'Paid',
      validity: '21 Feb 2026',
    },

    {
      id: '5',
      property: '4140 Parker Rd. Allentown, New Mexico 31134',
      access: 'Disabled',
      levyStatus: 'Paid',
      validity: '1 Sept 2026',
    },
  ],
  paymentHistory: [
    {
      id: 'p1',
      date: '01 Jan 2024',
      levyPeriod: 'Jan 2024',
      amount: 8000,
      status: 'Paid',
    },
    {
      id: 'p2',
      date: '01 Feb 2024',
      levyPeriod: 'Feb 2024',
      amount: 8000,
      status: 'Paid',
    },
    {
      id: 'p3',
      date: '01 Mar 2024',
      levyPeriod: 'Mar 2024',
      amount: 8000,
      status: 'Unpaid',
    },
    {
      id: 'p4',
      date: '01 Mar 2024',
      levyPeriod: 'Mar 2024',
      amount: 8000,
      status: 'Unpaid',
    },
    {
      id: 'p5',
      date: '01 Mar 2024',
      levyPeriod: 'Mar 2024',
      amount: 8000,
      status: 'Unpaid',
    },
    {
      id: 'p6',
      date: '01 Mar 2024',
      levyPeriod: 'Mar 2024',
      amount: 8000,
      status: 'Unpaid',
    },
  ],

  accessHistory: [
    {
      id: 'a1',
      residentName: 'Adeyemi Akpan',
      propertyAddress: '4140 Parker Rd. Allentown, New Mexico 31134',

      property: 'Block A - 4517 Washington Ave.',

      date: '01 Jan 2024',
      time: '08:30 AM',

      action: 'Access Denied',
      actionType: 'Manual Override',
      triggeredBy: 'Estate Manager',

      reason: 'Resident access',
      status: 'Disabled',
      trigger: 'System',
    },

    {
      id: 'a2',
      residentName: 'Adeyemi Akpan',
      propertyAddress: 'Block B - 4140 Parker Rd.',

      property: 'Block B - 4140 Parker Rd.',

      date: '02 Jan 2024',
      time: '09:15 PM',

      action: 'Payment Received',
      actionType: 'Automatic',
      triggeredBy: 'System',

      reason: 'Payment confirmed',
      status: 'Enabled',
      trigger: 'Admin',
    },

    {
      id: 'a3',
      residentName: 'Adeyemi Akpan',
      propertyAddress: 'Flat 12',

      property: 'Flat 12',

      date: '05 Jan 2024',
      time: '02:00 PM',

      action: 'Access Denied',
      actionType: 'Manual Override',
      triggeredBy: 'Estate Manager',

      reason: 'Invalid credentials',
      status: 'Disabled',
      trigger: 'System',
    },

    {
      id: 'a4',
      residentName: 'Adeyemi Akpan',
      propertyAddress: 'Block B - 4140 Parker Rd.',

      property: 'Block B - 4140 Parker Rd.',

      date: '06 Jan 2024',
      time: '11:20 AM',

      action: 'Payment Received',
      actionType: 'Automatic',
      triggeredBy: 'System',

      reason: 'Payment confirmed',
      status: 'Enabled',
      trigger: 'Admin',
    },

    {
      id: 'a5',
      residentName: 'Adeyemi Akpan',
      propertyAddress: 'Flat 12',

      property: 'Flat 12',

      date: '07 Jan 2024',
      time: '04:45 PM',

      action: 'Access Denied',
      actionType: 'Manual Override',
      triggeredBy: 'Estate Manager',

      reason: 'Expired levy',
      status: 'Disabled',
      trigger: 'System',
    },
  ],
}

